var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1000,
    height: 1000,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-background-color-11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1000,
    height: 1000
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 279 7v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,296,24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 381 7v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,398,24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 415 7v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,432,24)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534,
    cy: 24,
    r: 17,
    transform: "rotate(0,534,24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585 7v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,602,24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 7,
    width: 34,
    height: 34,
    transform: "rotate(0,636,24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653,
    y: 7,
    width: 34,
    height: 34,
    transform: "rotate(0,670,24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687 7v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,704,24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 41v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,296,58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347 41v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,364,58)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 58,
    r: 17,
    transform: "rotate(0,466,58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 551 41v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,568,58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585 41v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,602,58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347 75v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,364,92)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 92,
    r: 17,
    transform: "rotate(0,432,92)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 92,
    r: 17,
    transform: "rotate(0,500,92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 619 75v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,636,92)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 126,
    r: 17,
    transform: "rotate(0,330,126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 381 109v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,398,126)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534,
    cy: 126,
    r: 17,
    transform: "rotate(0,534,126)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585 109v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,602,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 109,
    width: 34,
    height: 34,
    transform: "rotate(0,636,126)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 143,
    width: 34,
    height: 34,
    transform: "rotate(0,398,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 415 143v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,432,160)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 160,
    r: 17,
    transform: "rotate(0,500,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 551 143v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,568,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 143,
    width: 34,
    height: 34,
    transform: "rotate(0,602,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 143,
    width: 34,
    height: 34,
    transform: "rotate(0,636,160)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653,
    y: 143,
    width: 34,
    height: 34,
    transform: "rotate(0,670,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687 143v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,704,160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 381 177v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,398,194)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 177,
    width: 34,
    height: 34,
    transform: "rotate(0,568,194)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585 177v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,602,194)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 228,
    r: 17,
    transform: "rotate(0,296,228)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 364,
    cy: 228,
    r: 17,
    transform: "rotate(0,364,228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 415 211v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,432,228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 483 211v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,500,228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 551 211v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,568,228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 619 211v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,636,228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687 211v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,704,228)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 381 245v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,398,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 245,
    width: 34,
    height: 34,
    transform: "rotate(0,432,262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 483 245v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(180,500,262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 517 245v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,534,262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585 245v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,602,262)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 619 245v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,636,262)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687,
    y: 245,
    width: 34,
    height: 34,
    transform: "rotate(0,704,262)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 296,
    r: 17,
    transform: "rotate(0,58,296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 211 279v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,228,296)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 279,
    width: 34,
    height: 34,
    transform: "rotate(0,262,296)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 279,
    width: 34,
    height: 34,
    transform: "rotate(0,296,296)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 279,
    width: 34,
    height: 34,
    transform: "rotate(0,330,296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347 279v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,364,296)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 279,
    width: 34,
    height: 34,
    transform: "rotate(0,432,296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 449 279v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,466,296)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 568,
    cy: 296,
    r: 17,
    transform: "rotate(0,568,296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 653 279v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,670,296)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687,
    y: 279,
    width: 34,
    height: 34,
    transform: "rotate(0,704,296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 279v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,738,296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 925 279v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,942,296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 959 279v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,976,296)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 330,
    r: 17,
    transform: "rotate(0,24,330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 143 313v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,160,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 313,
    width: 34,
    height: 34,
    transform: "rotate(0,296,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 313,
    width: 34,
    height: 34,
    transform: "rotate(0,364,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 313,
    width: 34,
    height: 34,
    transform: "rotate(0,398,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 313,
    width: 34,
    height: 34,
    transform: "rotate(0,432,330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 517 313v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,534,330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585 313v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,602,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 313,
    width: 34,
    height: 34,
    transform: "rotate(0,636,330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 653 313v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,670,330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 789 313v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,806,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 313,
    width: 34,
    height: 34,
    transform: "rotate(0,840,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 313,
    width: 34,
    height: 34,
    transform: "rotate(0,874,330)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 891,
    y: 313,
    width: 34,
    height: 34,
    transform: "rotate(0,908,330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 925 313v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,942,330)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75 347v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,92,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,126,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,160,364)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 364,
    r: 17,
    transform: "rotate(0,228,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,296,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,330,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,364,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,398,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,432,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,466,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,500,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,534,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,568,364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585 347v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,602,364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 347v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,738,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 755,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,772,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,806,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,840,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 347,
    width: 34,
    height: 34,
    transform: "rotate(0,874,364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 891 347v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,908,364)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 381,
    width: 34,
    height: 34,
    transform: "rotate(0,160,398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 381v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,262,398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 381v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,296,398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 381 381v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(180,398,398)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 381,
    width: 34,
    height: 34,
    transform: "rotate(0,432,398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 449 381v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,466,398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 551 381v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,568,398)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636,
    cy: 398,
    r: 17,
    transform: "rotate(0,636,398)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 755,
    y: 381,
    width: 34,
    height: 34,
    transform: "rotate(0,772,398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 823 381v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(180,840,398)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 381,
    width: 34,
    height: 34,
    transform: "rotate(0,874,398)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 432,
    r: 17,
    transform: "rotate(0,58,432)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 415,
    width: 34,
    height: 34,
    transform: "rotate(0,160,432)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 415,
    width: 34,
    height: 34,
    transform: "rotate(0,194,432)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 415,
    width: 34,
    height: 34,
    transform: "rotate(0,228,432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 415v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,262,432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 483 415v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,500,432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 517 415v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,534,432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 653 415v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,670,432)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687,
    y: 415,
    width: 34,
    height: 34,
    transform: "rotate(0,704,432)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 415,
    width: 34,
    height: 34,
    transform: "rotate(0,738,432)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 755,
    y: 415,
    width: 34,
    height: 34,
    transform: "rotate(0,772,432)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 415,
    width: 34,
    height: 34,
    transform: "rotate(0,874,432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 925 415v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,942,432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 109 449v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,126,466)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 449,
    width: 34,
    height: 34,
    transform: "rotate(0,160,466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 449v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,296,466)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 449,
    width: 34,
    height: 34,
    transform: "rotate(0,330,466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347 449v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,364,466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 415 449v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,432,466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 619 449v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,636,466)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653,
    y: 449,
    width: 34,
    height: 34,
    transform: "rotate(0,670,466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687 449v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,704,466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 755 449v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,772,466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 823 449v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,840,466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 857 449v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,874,466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 925 449v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(180,942,466)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 959 449v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,976,466)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 500,
    r: 17,
    transform: "rotate(0,24,500)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 500,
    r: 17,
    transform: "rotate(0,92,500)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 483,
    width: 34,
    height: 34,
    transform: "rotate(0,160,500)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 500,
    r: 17,
    transform: "rotate(0,228,500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 483v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(180,296,500)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 483,
    width: 34,
    height: 34,
    transform: "rotate(0,330,500)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 483,
    width: 34,
    height: 34,
    transform: "rotate(0,364,500)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 483,
    width: 34,
    height: 34,
    transform: "rotate(0,398,500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 415 483v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,432,500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 517 483v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,534,500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 551 483v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,568,500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 619 483v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,636,500)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 806,
    cy: 500,
    r: 17,
    transform: "rotate(0,806,500)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 109 517v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,126,534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 143 517v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,160,534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347 517v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,364,534)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 534,
    r: 17,
    transform: "rotate(0,466,534)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 670,
    cy: 534,
    r: 17,
    transform: "rotate(0,670,534)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 772,
    cy: 534,
    r: 17,
    transform: "rotate(0,772,534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 823 517v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,840,534)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 517,
    width: 34,
    height: 34,
    transform: "rotate(0,874,534)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 891,
    y: 517,
    width: 34,
    height: 34,
    transform: "rotate(0,908,534)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 925 517v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,942,534)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 568,
    r: 17,
    transform: "rotate(0,58,568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 109 551v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,126,568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 177 551v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,194,568)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 551,
    width: 34,
    height: 34,
    transform: "rotate(0,228,568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 245 551v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,262,568)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636,
    cy: 568,
    r: 17,
    transform: "rotate(0,636,568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687 551v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,704,568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 551v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,738,568)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 551,
    width: 34,
    height: 34,
    transform: "rotate(0,874,568)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 891,
    y: 551,
    width: 34,
    height: 34,
    transform: "rotate(0,908,568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 959 551v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,976,568)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7 585v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,24,602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75 585v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,92,602)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 602,
    r: 17,
    transform: "rotate(0,160,602)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 585,
    width: 34,
    height: 34,
    transform: "rotate(0,262,602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 585v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,296,602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347 585v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,364,602)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 585,
    width: 34,
    height: 34,
    transform: "rotate(0,398,602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 415 585v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,432,602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 551 585v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,568,602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 653 585v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,670,602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687 585v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,704,602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 755 585v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,772,602)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789,
    y: 585,
    width: 34,
    height: 34,
    transform: "rotate(0,806,602)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 585,
    width: 34,
    height: 34,
    transform: "rotate(0,840,602)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 585,
    width: 34,
    height: 34,
    transform: "rotate(0,874,602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 891 585v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,908,602)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 959,
    y: 585,
    width: 34,
    height: 34,
    transform: "rotate(0,976,602)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,24,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,58,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,92,636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 109 619v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,126,636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 177 619v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,194,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,228,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,262,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,296,636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 313 619v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,330,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,398,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,432,636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 449 619v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,466,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,568,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,602,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,636,636)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 653 619v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,670,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,874,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 959,
    y: 619,
    width: 34,
    height: 34,
    transform: "rotate(0,976,636)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 653,
    width: 34,
    height: 34,
    transform: "rotate(0,24,670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 143 653v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,160,670)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 653,
    width: 34,
    height: 34,
    transform: "rotate(0,262,670)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 653,
    width: 34,
    height: 34,
    transform: "rotate(0,296,670)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 653,
    width: 34,
    height: 34,
    transform: "rotate(0,330,670)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 653,
    width: 34,
    height: 34,
    transform: "rotate(0,364,670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 381 653v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,398,670)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 653,
    width: 34,
    height: 34,
    transform: "rotate(0,466,670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 517 653v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,534,670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 551 653v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,568,670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 653v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,738,670)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 755,
    y: 653,
    width: 34,
    height: 34,
    transform: "rotate(0,772,670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 789 653v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,806,670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 857 653v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,874,670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 925 653v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,942,670)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 959,
    y: 653,
    width: 34,
    height: 34,
    transform: "rotate(0,976,670)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7 687v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,24,704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75 687v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,92,704)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 687,
    width: 34,
    height: 34,
    transform: "rotate(0,126,704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 143 687v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,160,704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 211 687v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,228,704)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 687,
    width: 34,
    height: 34,
    transform: "rotate(0,262,704)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 687,
    width: 34,
    height: 34,
    transform: "rotate(0,296,704)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 687,
    width: 34,
    height: 34,
    transform: "rotate(0,330,704)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 687,
    width: 34,
    height: 34,
    transform: "rotate(0,466,704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 483 687v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,500,704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585 687v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,602,704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 687 687v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,704,704)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 687,
    width: 34,
    height: 34,
    transform: "rotate(0,738,704)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 755,
    y: 687,
    width: 34,
    height: 34,
    transform: "rotate(0,772,704)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789,
    y: 687,
    width: 34,
    height: 34,
    transform: "rotate(0,806,704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 823 687v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,840,704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 891 687v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(-90,908,704)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 925,
    y: 687,
    width: 34,
    height: 34,
    transform: "rotate(0,942,704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 959 687v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,976,704)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 721,
    width: 34,
    height: 34,
    transform: "rotate(0,296,738)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313,
    y: 721,
    width: 34,
    height: 34,
    transform: "rotate(0,330,738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347 721v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,364,738)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 721,
    width: 34,
    height: 34,
    transform: "rotate(0,466,738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 517 721v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,534,738)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 721,
    width: 34,
    height: 34,
    transform: "rotate(0,602,738)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 721,
    width: 34,
    height: 34,
    transform: "rotate(0,636,738)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653,
    y: 721,
    width: 34,
    height: 34,
    transform: "rotate(0,670,738)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687,
    y: 721,
    width: 34,
    height: 34,
    transform: "rotate(0,704,738)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 721,
    width: 34,
    height: 34,
    transform: "rotate(0,840,738)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 721,
    width: 34,
    height: 34,
    transform: "rotate(0,874,738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 891 721v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,908,738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 755v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,296,772)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 381 755v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(-90,398,772)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 755,
    width: 34,
    height: 34,
    transform: "rotate(0,466,772)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 517,
    y: 755,
    width: 34,
    height: 34,
    transform: "rotate(0,534,772)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 755,
    width: 34,
    height: 34,
    transform: "rotate(0,568,772)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 755,
    width: 34,
    height: 34,
    transform: "rotate(0,602,772)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653,
    y: 755,
    width: 34,
    height: 34,
    transform: "rotate(0,670,772)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687,
    y: 755,
    width: 34,
    height: 34,
    transform: "rotate(0,704,772)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 772,
    cy: 772,
    r: 17,
    transform: "rotate(0,772,772)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 755,
    width: 34,
    height: 34,
    transform: "rotate(0,840,772)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 806,
    r: 17,
    transform: "rotate(0,330,806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 789,
    width: 34,
    height: 34,
    transform: "rotate(0,398,806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 789,
    width: 34,
    height: 34,
    transform: "rotate(0,466,806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 517 789v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(180,534,806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551,
    y: 789,
    width: 34,
    height: 34,
    transform: "rotate(0,568,806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 789,
    width: 34,
    height: 34,
    transform: "rotate(0,602,806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 789,
    width: 34,
    height: 34,
    transform: "rotate(0,636,806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653,
    y: 789,
    width: 34,
    height: 34,
    transform: "rotate(0,670,806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687,
    y: 789,
    width: 34,
    height: 34,
    transform: "rotate(0,704,806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 789,
    width: 34,
    height: 34,
    transform: "rotate(0,840,806)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 857 789v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,874,806)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 823,
    width: 34,
    height: 34,
    transform: "rotate(0,398,840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 823,
    width: 34,
    height: 34,
    transform: "rotate(0,432,840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 449 823v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,466,840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 823,
    width: 34,
    height: 34,
    transform: "rotate(0,602,840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653,
    y: 823,
    width: 34,
    height: 34,
    transform: "rotate(0,670,840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687,
    y: 823,
    width: 34,
    height: 34,
    transform: "rotate(0,704,840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 823,
    width: 34,
    height: 34,
    transform: "rotate(0,738,840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 755,
    y: 823,
    width: 34,
    height: 34,
    transform: "rotate(0,772,840)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789,
    y: 823,
    width: 34,
    height: 34,
    transform: "rotate(0,806,840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 823 823v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,840,840)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 840,
    r: 17,
    transform: "rotate(0,976,840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 313 857v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,330,874)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347,
    y: 857,
    width: 34,
    height: 34,
    transform: "rotate(0,364,874)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 857,
    width: 34,
    height: 34,
    transform: "rotate(0,398,874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585 857v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(180,602,874)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 857,
    width: 34,
    height: 34,
    transform: "rotate(0,636,874)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653,
    y: 857,
    width: 34,
    height: 34,
    transform: "rotate(0,670,874)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687,
    y: 857,
    width: 34,
    height: 34,
    transform: "rotate(0,704,874)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789,
    y: 857,
    width: 34,
    height: 34,
    transform: "rotate(0,806,874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 857 857v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,874,874)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 891,
    y: 857,
    width: 34,
    height: 34,
    transform: "rotate(0,908,874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 925 857v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,942,874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347 891v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(180,364,908)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381,
    y: 891,
    width: 34,
    height: 34,
    transform: "rotate(0,398,908)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 891,
    width: 34,
    height: 34,
    transform: "rotate(0,432,908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 449 891v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,466,908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 517 891v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,534,908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 551 891v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,568,908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 653 891v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(180,670,908)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687,
    y: 891,
    width: 34,
    height: 34,
    transform: "rotate(0,704,908)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 721,
    y: 891,
    width: 34,
    height: 34,
    transform: "rotate(0,738,908)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 755,
    y: 891,
    width: 34,
    height: 34,
    transform: "rotate(0,772,908)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 789,
    y: 891,
    width: 34,
    height: 34,
    transform: "rotate(0,806,908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 823 891v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,840,908)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 925 891v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,942,908)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 942,
    r: 17,
    transform: "rotate(0,296,942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 381 925v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(180,398,942)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415,
    y: 925,
    width: 34,
    height: 34,
    transform: "rotate(0,432,942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 449 925v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(90,466,942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 551 925v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,568,942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 721 925v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,738,942)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 925,
    width: 34,
    height: 34,
    transform: "rotate(0,840,942)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 857,
    y: 925,
    width: 34,
    height: 34,
    transform: "rotate(0,874,942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 891 925v 34h 34v -17a 17 17, 0, 0, 0, -17 -17",
    transform: "rotate(0,908,942)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 976,
    cy: 942,
    r: 17,
    transform: "rotate(0,976,942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 313 959v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,330,976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 347 959v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,364,976)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 534,
    cy: 976,
    r: 17,
    transform: "rotate(0,534,976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 585 959v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(180,602,976)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 619,
    y: 959,
    width: 34,
    height: 34,
    transform: "rotate(0,636,976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 653 959v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(0,670,976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 823 959v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,840,976)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 891 959v 34h 17a 17 17, 0, 0, 0, 0 -34",
    transform: "rotate(90,908,976)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0-11"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 7 92v 68a 85 85, 0, 0, 0, 85 85h 68a 85 85, 0, 0, 0, 85 -85v -68a 85 85, 0, 0, 0, -85 -85h -68a 85 85, 0, 0, 0, -85 85M 92 41h 68a 51 51, 0, 0, 1, 51 51v 68a 51 51, 0, 0, 1, -51 51h -68a 51 51, 0, 0, 1, -51 -51v -68a 51 51, 0, 0, 1, 51 -51",
    transform: "rotate(0,126,126)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0-11"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 126,
    r: 51,
    transform: "rotate(0,126,126)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0-11"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 755 92v 68a 85 85, 0, 0, 0, 85 85h 68a 85 85, 0, 0, 0, 85 -85v -68a 85 85, 0, 0, 0, -85 -85h -68a 85 85, 0, 0, 0, -85 85M 840 41h 68a 51 51, 0, 0, 1, 51 51v 68a 51 51, 0, 0, 1, -51 51h -68a 51 51, 0, 0, 1, -51 -51v -68a 51 51, 0, 0, 1, 51 -51",
    transform: "rotate(90,874,126)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0-11"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 874,
    cy: 126,
    r: 51,
    transform: "rotate(90,874,126)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1-11"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 7 840v 68a 85 85, 0, 0, 0, 85 85h 68a 85 85, 0, 0, 0, 85 -85v -68a 85 85, 0, 0, 0, -85 -85h -68a 85 85, 0, 0, 0, -85 85M 92 789h 68a 51 51, 0, 0, 1, 51 51v 68a 51 51, 0, 0, 1, -51 51h -68a 51 51, 0, 0, 1, -51 -51v -68a 51 51, 0, 0, 1, 51 -51",
    transform: "rotate(-90,126,874)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1-11"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 874,
    r: 51,
    transform: "rotate(-90,126,874)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 1000,
    width: 1000,
    clipPath: "url('#clip-path-background-color-11')",
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 1000,
    width: 1000,
    clipPath: "url('#clip-path-dot-color-11')",
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    height: 238,
    width: 238,
    clipPath: "url('#clip-path-corners-square-color-0-0-11')",
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 75,
    height: 102,
    width: 102,
    clipPath: "url('#clip-path-corners-dot-color-0-0-11')",
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 755,
    y: 7,
    height: 238,
    width: 238,
    clipPath: "url('#clip-path-corners-square-color-1-0-11')",
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 75,
    height: 102,
    width: 102,
    clipPath: "url('#clip-path-corners-dot-color-1-0-11')",
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 755,
    height: 238,
    width: 238,
    clipPath: "url('#clip-path-corners-square-color-0-1-11')",
    fill: "#000000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 823,
    height: 102,
    width: 102,
    clipPath: "url('#clip-path-corners-dot-color-0-1-11')",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr-code.5fc902af25217a1da78d4b0bec8b850b.svg";
export { ForwardRef as ReactComponent };